/* prettier-ignore */

const HOME_PATH = '/home';
const OFFLINE_HIKING_PATH = '/offline-hiking';
const OFFLINE_ROUTES_PATH = '/offline-routes';

export function isOfflineHikingPage(url: string): boolean {
  return url.startsWith(OFFLINE_HIKING_PATH);
}

export function isOfflineRoutesPage(url: string): boolean {
  return url.startsWith(OFFLINE_ROUTES_PATH);
}

export function shouldHideLogoOffline(url: string, isOnline: boolean): boolean {
  return !isOnline && (isOfflineHikingPage(url) || isOfflineRoutesPage(url));
}

export function shouldHideBackButtonOffline(url: string, isOnline: boolean): boolean {
  return !isOnline && isOfflineRoutesPage(url);
}

export function shouldShowBackButton(url: string, isTechEditMode: boolean): boolean {
  return !url.includes(HOME_PATH) && !isTechEditMode;
}

export function shouldShowBackToDistributor(url: string, homeDistributor: string | undefined): boolean {
  return Boolean(homeDistributor) && url.includes(HOME_PATH);
}
